import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import classes from "./styles.module.css";
import Form from "react-validation/build/form";
import APIConfig from "../../../api/APIConfig";
import swal from 'sweetalert';
import AuthService from "../../../services/auth.service";
import ReactLoading from "react-loading";
import {
    Box,
    Text,
    Button,
    Badge,
    VStack,
    HStack,
    Center,
    Textarea,
    FormLabel,
    FormControl,
  } from '@chakra-ui/react';


function FeedbackLaporan() {
    const navigate = useNavigate();
    const [feedback, setFeedback] = useState("");
    const [status, setStatus] = useState("");
    const [namaPeserta, setNamaPeserta] = useState("");
    const [waktuPost, setWaktuPost] = useState("");
    const [namaProposal, setNamaProposal] = useState("");
    const [topik, setTopik] = useState("");
    const [laporan, setLaporan] = useState("");
    const [bulan, setBulan] = useState("");
    const [minggu, setMinggu] = useState("");
    const [spinner, setSpinner] = useState(false); 

    const currentUser = AuthService.getCurrentUser();
    let idMentor;
    currentUser.mentor.map((data) => idMentor=data.idMentor)

    const [validation, setValidation] = useState({});
    const { id } = useParams();
    const { idLowonganPeserta } = useParams();

    const getLaporanById = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/laporan/${id}`);
        const data = await response.data
        console.log(data);
        setNamaPeserta(data.namaPeserta);
        setLaporan(data.isiLaporan);
        setNamaProposal(data.namaKegiatan);
        setWaktuPost(data.waktuPost);
        setTopik(data.topik);
        setFeedback(data.feedback);
        setStatus(data.status);

        if( (data.bulan) === 1 ) 
            setBulan("Januari");

        if( (data.bulan) === 2 ) 
            setBulan("Februari");

        if( (data.bulan) === 3 ) 
            setBulan("Maret");
    
        if( (data.bulan) === 4 ) 
            setBulan("April");

        if( (data.bulan) === 5 ) 
            setBulan("Mei");

        if( (data.bulan) === 6 ) 
            setBulan("Juni");

        if( (data.bulan) === 7 ) 
            setBulan("Juli");

        if( (data.bulan) === 8 ) 
            setBulan("Agustus");
    
        if( (data.bulan) === 9 ) 
            setBulan("September");

        if( (data.bulan) === 10 ) 
            setBulan("Oktober");

        if( (data.bulan) === 11 ) 
            setBulan("November");

        if( (data.bulan) === 12 ) 
            setBulan("Desember");

        
        setMinggu(data.minggu);


        setSpinner(false);
    };

    useEffect(() => {
        getLaporanById();
        
    }, []);

    const terimaLaporan = async (e) => {
        e.preventDefault();
        swal("Apakah anda yakin untuk menyetujui laporan ini?", {
        buttons: {
            yes: {
            text: "Ya",
            value: "yes"
            },
            no: {
            text: "Tidak",
            value: "no"
            }
        }
        }).then((value) => {
        if (value === "yes") {
            APIConfig.put(`v1/laporan/feedback/${id}/${idMentor}`, {
                feedback: feedback,
                status: "Diterima",
                
            })
            .then(() => {
                console.log("berhasil") 
                swal({
                    title: "Laporan telah berhasil disetujui",
                    icon: "success",
                    button: "OK",
                }).then(() => {
                    navigate(`/mentor/manajemenmentee/listlaporanpeserta/${idMentor}/${idLowonganPeserta}`);
                });
            })
            .catch((error) => {
                console.log(error);
                setValidation(error.response.data);
            })
        }
        return false;
        });
    };

    const tolakLaporan = async (e) => {
        e.preventDefault();
        swal("Apakah anda yakin untuk menolak laporan ini?", {
        buttons: {
            yes: {
            text: "Ya",
            value: "yes"
            },
            no: {
            text: "Tidak",
            value: "no"
            }
        }
        }).then((value) => {
        if (value === "yes") {
            APIConfig.put(`v1/laporan/feedback/${id}/${idMentor}`, {
                feedback: feedback,
                status: "Ditolak",
               
            })
            .then(() => {
                console.log("berhasil") 
                swal({
                    title: "Laporan telah berhasil ditolak",
                    icon: "success",
                    button: "OK",
                }).then(() => {
                    navigate(`/mentor/manajemenmentee/listlaporanpeserta/${idMentor}/${idLowonganPeserta}`);
                });
            })
            .catch((error) => {
                console.log(error);
                setValidation(error.response.data);
            })
        }
        return false;
        });
    };

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return(
        <Center py={6}>
        <VStack align='stretch' justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                fontFamily={'Inter'}>
                Persetujuan Laporan Peserta
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to={`/mentor/manajemenmentee/list-mentee/${idMentor}`}> Mentee Management</Link>
                <p> / </p>
                <Link to={`/mentor/manajemenmentee/listlaporanpeserta/${idMentor}/${idLowonganPeserta}`}> List Laporan Peserta </Link>
                <p> / </p>
                <Link to=""> Feedback Laporan</Link>
            </HStack>
                <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                    <VStack align='stretch' justifyItems='left' spacing={4}>
                        <HStack justifyContent='space-between' direction='row' spacing={4} align='center'>
                            <VStack align= "stretch">
                                <p style={{'fontWeight':'bold'}}>{namaPeserta}</p> 
                                <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}}>{bulan}, Minggu ke-{minggu}</p>
                            </VStack>
                            <VStack spacing={1}>
                                <Badge p={2} m={2} colorScheme='purple' fontSize='12px'>{status}</Badge>
                                <p style={{'fontSize':'13px', 'color':'GrayText'}}>{waktuPost}</p> 
                            </VStack>
                        </HStack>
                        <hr>
                        </hr>
                        <VStack align='stretch' spacing={2}>
                            <h3 className={classes.h} >Kegiatan</h3>
                            <p className={classes.p}>{namaProposal}</p>
                        </VStack>
                        <VStack align='stretch' spacing={2}>
                            <h3 className={classes.h} >Topik</h3>
                            <p className={classes.p}>{topik}</p>
                        </VStack>
                        <VStack align='stretch' spacing={2}>
                            <h3 className={classes.h} >Laporan</h3>
                            <p className={classes.p}>{laporan}</p>
                        </VStack>

                        <Form p={6}>
                            <FormControl pb={6} fontFamily={'Inter'}>
                            <FormLabel 
                                fontFamily={'Inter'}
                                fontSize={'14px'}
                                fontWeight={'600'}
                                color={'blueviolet'}
                                htmlFor='feedback'>Feedback</FormLabel>
                            <Textarea 
                            type='text'
                            fontFamily={'Inter'}
                            fontSize={'14px'}
                            id='feedback' 
                            placeholder='Berikan feedback untuk laporan peserta..' 
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}/>
                            </FormControl>
                        </Form>

                        <HStack pr={6} align="end" pb={10} justifyContent='right' direction='row' spacing={2} alignItems='center'>
                            <Button 
                                p={6}
                                onClick={terimaLaporan}
                                fontSize={'small'}
                                color="white"
                                type='submit'
                                
                                backgroundColor={'green.700'} 
                                rounded={'xl'}
                                variant='solid'>
                                Setujui
                            </Button>
                            <Button 
                                p={6}
                                onClick={tolakLaporan}
                                fontSize={'small'}
                                color="white"
                                type='submit'
                                
                                backgroundColor={'red.700'} 
                                rounded={'xl'}
                                variant='solid'>
                                Tolak
                            </Button>
                        </HStack>
                    </VStack>
                    </Box>        
        </VStack>
        </Center>
    );
}

export default FeedbackLaporan;